import { makeStyles } from '@material-ui/core'
import React from 'react'
import { colors } from '../../Themes'
import Text from '../Text'
import { Arrow } from '../../Themes/Images'

const cardHolderStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: 450,
    height: 542,
    borderRadius: 5,
    background: colors.white,
    border: '1px solid white',
    position: 'relative',
    flexShrink: 0,
    [theme.breakpoints.down(600)]: {
      width: 380,
    },
    [theme.breakpoints.down(760)]: {
      height: 468,
    },
    [theme.breakpoints.down(450)]: {
      width: 320,
    },
  },
  image: {
    width: '100%',
    height: 220
  },
  img: {
    objectFit: 'contain'
  },
  bottomPart: {
    paddingInline: 16,
    paddingTop: 16,
    paddingBottom: 26,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    position: 'relative'
  },
  title: {
    marginBottom: 16
  },
  description: {
    marginBottom: 25,
    [theme.breakpoints.down(760)]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      '-webkit-box-orient': 'vertical',
    },
  },
  link: {
    textDecoration: 'none',
    color: colors.primary,
    '&:hover': {
      textDecoration: 'none',
      color: colors.primary,
    },
  },
}))

const CardHolder = ({ item }) => {
  const classes = cardHolderStyles()
  return (
    <article className={classes.card} key={item.id}>
      <div className={classes.image}>
        <img src={item.url} alt='Image representing the article' className={classes.img} style={{ width: '100%', height: 220, objectFit: 'cover' }} />
      </div>
      <div className={classes.bottomPart}>
        <div>
          <div className={classes.title}>
            <Text weight='bold' size='h3'>{item.title}</Text>
          </div>
          <div className={classes.description}>
            <Text size='body'>{item.description}</Text>
          </div>
        </div>
        <div className={classes.linkSection}>
          <Text size='body'>
            <a className={classes.link} href={item.link} target='_blank' rel="noreferrer">Read more <Arrow style={{ marginLeft: 8 }} /></a>
          </Text>
        </div>
      </div>
    </article>
  )
}

export default CardHolder